import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import encryptData from "../../utils/encryption";
import { loginRequest } from "../../auth-config";
import Loader from '../../assets/loader.gif';
import { toast, ToastContainer } from 'react-toastify';
import {
  Button,
  Form,
  Spinner,
  Alert as AlertMessage,
  Col,
  Row,
  Container,
} from "react-bootstrap";
import godrejLogo from "../../assets/images/godrej-logo-dark.svg";
import blockImg from "../../assets/images/blockImg.svg";
import tickImage from "../../assets/images/tickImage.svg";
import "../../layout/pages/login.css";
import InputBox from "../common/InputBox";
import { authenticate } from "../../services/user-service";
import "../../utils/interceptor";
import Alert from "../common/Alert";

const Login = (props) => {
  console.log("props", props);
  const [idToken, setIdToken] = useState(null);
  const [salCode, setSalCode] = useState("");
  const [dob, setDob] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [resendTimer, setResendTimer] = useState(0);
  const [validUser, setValidUser] = useState(true);
  const otpBoxReference = useRef([]);
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [errors, setErrors] = useState({});
  const [loader, setLoader] = useState(true)
  console.log("B2CAccount", accounts);
  console.log("prACHI", process.env.REACT_APP_B2C_TENANTID);

  useEffect(() => {
    // debugger;
    let isLoggedIn=sessionStorage.getItem("isLoggedIn");
    if ((accounts.length == 0 || B2CAccount.length == 0) && sessionStorage.getItem("isLoggedIn")==false) {
      instance.loginRedirect(loginRequest).catch((e) => {
        console.error(e);
      });
    }

  }, []);
  // let B2CAccount = accounts.filter(accounts => accounts.tenantId.includes(process.env.REACT_APP_B2C_TENANTID));
  // console.log("B2CAccount", B2CAccount);
  let B2CAccount = accounts.filter(accounts => accounts.homeAccountId.includes(process.env.REACT_APP_B2C_TENANTID));
  console.log("B2CAccount", B2CAccount);
  //  if(B2CAccount.length > 0)
  //   {

  //    B2CAccount[0].username="fff@gmail.com";
  //   }
  const handleB2CPage = async () => {
    console.log("process.env.REACT_APP_B2C_TENANTID", process.env.REACT_APP_B2C_TENANTID);
    console.log("accounts", accounts);
    if (B2CAccount.length > 0) {
      setLoading(true);
      await RequestProfileData();
      await getUserData();
      setLoading(false);
      // navigate("/home");
    } else {
      sessionStorage.setItem("isLoggedIn", true);
      instance.loginRedirect(loginRequest).catch((e) => {
        console.error(e);
      });
    }
  };


  useEffect(() => {
    const fetchData = async () => {
          const isloggedIn = sessionStorage.getItem("isLoggedIn");
      if (isAuthenticated && (isloggedIn === "true" || B2CAccount.length > 0)) {
        setLoading(true);
        await RequestProfileData();
        await getUserData();
        setLoading(false);
      }
    };
    fetchData();
  }, [isAuthenticated]);




  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const newOtp = [...otp];
      if (newOtp[index] === "") {
        if (e.target.previousSibling) {
          e.target.previousSibling.focus();
        }
      } else {
        newOtp[index] = "";
        setOtp(newOtp);
      }
    }
  };

  useEffect(() => {
    let timer;
    if (resendTimer > 0) {
      timer = setInterval(() => setResendTimer((prev) => prev - 1), 1000);
    }
    return () => clearInterval(timer);
  }, [resendTimer]);

  useEffect(() => {
    if (errorMessage) {
      navigate({
        pathname: "/",
        state: { errorMessage: errorMessage },
      });
    }
  }, [errorMessage]);

  async function RequestProfileData() {
    const request = {
      ...loginRequest,
      account: accounts[0],
    };
    await instance
      .acquireTokenSilent(request)
      .then((response) => {
        setIdToken(response.idToken);
        sessionStorage.setItem("Token", response.idToken);
        console.log("setIdToken", response.idToken);
      })
      .catch((e) => {
        instance.acquireTokenPopup(request).then((response) => {
          setIdToken(response.idToken);
          sessionStorage.setItem("Token", response.idToken);
        });
      });
  }

  async function getUserData() {
    // debugger;
    console.log("Inside Accounts Data", accounts[0]);
    let user = accounts[0].username;
    console.log(
      " user ",
      user,
      " ",
      accounts[0],
      " ,,,,,,,,,,,,,,,,,,,,,,,,,accounts[0] ,,,,,,,,,,,,,,,,,,,,,,,,,,,,"
    );
    sessionStorage.setItem("Token", accounts[0]?.idToken);
    let result = await authenticate(user)
      .then((result) => {

        console.log("***********************result**************** ", result);
        if (result?.data) {
          console.log(" userData ", result.data);
          sessionStorage.setItem(
            "UserData",
            result.data ? JSON.stringify(result.data) : ""
          );
          sessionStorage.setItem('Token', result.data.Token);
          props.setValidB2CUser(true);
          sessionStorage.setItem("isLoggedIn", true);
          setValidUser(true);

          window.location.pathname = "/home";

        } else {
          setValidUser(false);
          setErrorMessage("You are not authorized to access the system. Please contact the system administrator.");
          props.setValidB2CUser(false);
          sessionStorage.clear();
        }
      })
      .catch((err) => {
        console.log("Error in fetching details", err);
        const response = err;
        if (response.data.message == 'No Records Found!') {
          setValidUser(false);
          setErrorMessage("You are not authorized to access the system. Please contact the system administrator.");
          Alert("error", "You are not authorized to access the system. Please contact the system administrator.")
          props.setValidB2CUser(false);
          sessionStorage.clear();
        } else {
          setValidUser(false);
          setErrorMessage(err);
          sessionStorage.clear();
          Alert("error", response.data.message);
        }
      })
  }

  return (
    <>
      {loading && (
        <div className="loader-box">
          {" "}
          <img src={Loader} alt="Loading" className="newloader"></img>{" "}
        </div>
      )}
      <div className="container-login">
        <ToastContainer
          autoClose={process.env.TOAST_AUTO_CLOSE}
          className="logintoast-container"
          hideProgressBar={true}
          newestOnTop={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          closeButton={false}
          theme="colored"
          icon={false}
        />
        <div className="loginLeftImageGodrej d-flex justify-content-between align-items-center my-3">
          <img src={godrejLogo} alt="godrejLogo" />
          <span className="headerLink">Godrej Enterprises Group</span>
        </div>
        <Container fluid>
          <Row className="vh-100">
            <div className="login-container">
              <Col
                md={6}
                className="d-flex align-items-center justify-content-center loginLeft"
              >
                <div className="col-12 col-md-8 noPadMar bg-primary loginImg"></div>
                {/* <img src={loginImg} alt="Login" className="loginImg" /> */}
              </Col>
              <Col
                md={6}
                className="d-flex align-items-center justify-content-center loginRight"
              >
                <div className="loginForm">
                  <div className="loginHeader">Dealer Portal</div>
                  <Form>
                    <>
                      {/* <div className="signin"> Sign In</div> */}
                      <Button
                        variant="primary"
                        className="login-btn"
                        onClick={handleB2CPage}
                        style={{
                          backgroundColor:
                            salCode || dob ? "#ffffff" : "#810055",
                          color: salCode || dob ? "#707070" : "#ffffff",
                          border: "1px solid #f1f1ed",
                        }}
                      >
                        Login
                      </Button>
                    </>
                  </Form>
                </div>

              </Col>
            </div>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Login;
